import { BotId, NlpModelId } from '@feedyou/schema'
import _ from 'lodash'
import { NlpLogDbPartitionDescriptor } from '../../components/nlp/TrainingTab/types'
import { CollapseUnion, TestRunConfig, TestRunDescriptor } from '@feedyou/utils'

function ids(...givenIds: Array<string | undefined>) {
  return givenIds.join('---')
}

export const ServerApiTag = {
  FILES: 'FILES',
  FILE_CONTENT_TYPE: (id: BotId, filename: string) => ({
    type: 'FILE_EXISTS',
    id: ids(id, filename)
  }),
  COMMENTS: 'COMMENTS',
  UTTERANCE_REPORT: 'UTTERANCE_REPORT',
  UNPROCESSED_LOG: (id: BotId, partition: NlpLogDbPartitionDescriptor) =>
    // @ts-ignore
    ({ type: 'UNPROCESSED_LOG', id: ids(id, partition.type, partition.stepId) } as const),
  HOSTING_VERSIONS: 'HOSTING_VERSIONS',
  VISIT_STATISTICS: 'VISIT_STATISTICS',
  CONVERSATIONS_LIST: 'CONVERSATIONS_LIST',
  CURRENT_USER_PERMISSIONS_FOR_CURRENT_BOT: 'CURRENT_USER_PERMISSIONS_FOR_CURRENT_BOT',
  HOSTING_UPDATE_HISTORY: 'HOSTING_UPDATE_HISTORY',
  KNOWLEDGE_BASE_QUERY: 'KNOWLEDGE_BASE_QUERY',
  KNOWLEDGE_BASE_DOCUMENTS: (id: NlpModelId) => ({ type: 'KNOWLEDGE_BASE_DOCUMENTS', id }),
  KNOWLEDGE_BASE_DOCUMENT_CHUNKS: 'KNOWLEDGE_BASE_DOCUMENT_CHUNKS',
  KNOWLEDGE_BASE_PATHS: 'KNOWLEDGE_BASE_PATHS',
  KNOWLEDGE_BASE_PAST_INDEX_RUNS: (id: NlpModelId) => ({
    type: 'KNOWLEDGE_BASE_PAST_INDEX_RUNS',
    id
  }),
  KNOWLEDGE_BASE_DOCUMENT_CONTENT: 'KNOWLEDGE_BASE_DOCUMENT_CONTENT',
  CLOUD_SERVICES: 'CLOUD_SERVICES',
  NLP_CHAT_QUERY_LIST: 'NLP_CHAT_QUERY_LIST',
  BOTS_METADATA_LIST: 'BOTS_METADATA_LIST',
  SUGGEST_ENRICHED_DESCRIPTION: 'SUGGEST_ENRICHED_DESCRIPTION',

  BOT_CONFIG: (id: BotId) => ({ type: 'BOT_CONFIG', id } as const),
  BOT_FLOW: (id: BotId, version?: string) => ({ type: 'BOT_FLOW', id: ids(id, version) } as const),
  BOT_LATEST_SEMVER: (id: BotId) => ({ type: 'BOT_LATEST_SEMVER', id } as const),
  BOT_VERSIONS_LIST: (id: BotId) => ({ type: 'VERSION_LIST_FOR_CURRENT_BOT', id } as const),
  BOT_VERSION_DIFF: (id: BotId, version: string) =>
    ({ type: 'BOT_VERSION_DIFF', id: ids(id, version) } as const),
  USER_PERMISSIONS_FOR_BOT: (id: BotId) => ({ type: 'USER_PERMISSIONS_FOR_BOT', id } as const),
  BOT_DEPLOYED_TREE: (id: BotId) => ({ type: 'DEPLOYED_TREE', id } as const),

  BOT_TESTER_SCENARIOS: (id: BotId) => ({ type: 'BOT_TESTER_SCENARIOS', id } as const),

  BOT_TESTER_RECORDED_RUNS: (config: CollapseUnion<TestRunConfig<any>>) => ({
    type: 'BOT_TESTER_RECORDED_RUNS',
    id: ids(config.botId, config.mode, config.scenarioId ?? config.testedUserId)
  }),
  BOT_TESTER_RECORDED_RUN: (d: CollapseUnion<TestRunDescriptor<any>>) => ({
    type: 'BOT_TESTER_RECORDED_RUN',
    id: ids(d.botId, d.mode, d.scenarioId ?? d.testedUserId, String(d.reversedMicroTimestamp))
  }),
  BOT_WIZARD: (id: BotId) => ({ type: 'BOT_WIZARD', id } as const)
} as const

export const TAG_TYPES = Object.values(ServerApiTag).map(value => {
  return _.isFunction(value) // I <3 PRETTIER
    ? // @ts-ignore
      value('x', 'y' as any).type
    : value
})
